export const FilterType = {
  NEW_COACHES: 'NewCoachesItems',
  FIBC: 'FIBCItems',
  RANK: 'rankItems',
} as const;
export type FilterType = (typeof FilterType)[keyof typeof FilterType];
